// Textos del paso 10 según si la cadena ofrece el bono de bienvenida (su promo activa) o no.
// Sin bono el paso es el mismo, pero no nombra el bono ni su monto.

export interface WelcomeCopy {
    title: string;
    continueLabel: string;
    exitLabel: string;
    exitTitle: string;
    exitDescription: string;
}

const WITH_BONUS: WelcomeCopy = {
    title: 'Activa el regalo de bienvenida',
    continueLabel: 'Recibir bono y continuar',
    exitLabel: 'Salir sin bono',
    exitTitle: '¿Salir sin bono?',
    exitDescription: 'El bono queda en Pendientes para otra visita.',
};

const WITHOUT_BONUS: WelcomeCopy = {
    title: 'Bienvenida',
    continueLabel: 'Continuar',
    exitLabel: 'Salir sin activar',
    exitTitle: '¿Salir sin activar?',
    exitDescription: 'El paso queda en Pendientes para otra visita.',
};

/** Mientras el bono no carga se asume que aplica: es el caso común y así no parpadea el copy. */
export function welcomeCopy(bonus: { active: boolean } | undefined): WelcomeCopy {
    return bonus?.active === false ? WITHOUT_BONUS : WITH_BONUS;
}

export function offersWelcomeBonus(bonus: { active: boolean } | undefined): boolean {
    return bonus?.active !== false;
}
